import CssPreloadingService from './Service/CssPreloadingService'
import CursorBurstAnimationService from './Service/CursorBurstAnimationService'

const cssPreloadingService = new CssPreloadingService()
cssPreloadingService.init()

const cursorBurstAnimationService = new CursorBurstAnimationService()
cursorBurstAnimationService.init()
